import { render, staticRenderFns } from "./CatalogVehicle.vue?vue&type=template&id=9f452f78&"
import script from "./CatalogVehicle.vue?vue&type=script&lang=js&"
export * from "./CatalogVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports